import { EntityKeyByReference, Note } from '@card-software/library';
import { OutgoingReceiptLineBase } from '../receipt-line-base';
import { AuditTrail } from '@card-software/nexus-models';
import { Translation } from '../translation';
import { StatusHistoryEntry } from './goods-receipt';

export enum StatusMaterialIssue {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Cancelled = 3,
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface MaterialIssueLine extends OutgoingReceiptLineBase {}

export interface MaterialIssue extends AuditTrail {
  /** Descends from an Administrative purchase order (#5942); only role holders can see it, the API enforces. */
  isAdministrative?: boolean;
  id?: string;
  number?: string;
  initiator: EntityKeyByReference;
  status: StatusMaterialIssue;
  locationCode: string;
  locationName?: Translation;
  issuedDate?: Date;
  lines: MaterialIssueLine[];
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<StatusMaterialIssue>[];
}
